import {Model, ModelMixin} from '../../common/model.class';
import moment = require('moment');
import Moment = moment.Moment;

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
export class Ecfmg extends ModelMixin() implements Model<Ecfmg> {

    TYPE = Ecfmg;

    certificateNumber?: string;
    dateIssued?: Moment;

    constructor(jsonData: any = {}) {
        super();
        if (jsonData.dateIssued) jsonData.dateIssued = moment(jsonData.dateIssued);
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/education/ecfmg/ecfmg.model.ts